
export type UpdateNotificationSettingsBodyTypeSettings = {[key: string]: boolean};
